import { useMemo } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { Funnel } from "@b2bportal/core-types";
import {
  ACTIVITIES_PATH,
  getPackageRoutes,
  FLIGHTS_PATH,
  TRIPS_PATH,
} from "@b2bportal/core-utilities/overridable";
import { HOTELS_PATH, HOMES_PATH } from "../constants";

/**
 * Hook that determines the current funnel based on the current route pathname.
 * @returns The current Funnel type, or undefined if not in any recognized funnel.
 */
export const useGetCurrentFunnel = (): Funnel | undefined => {
  const location = useLocation();

  return useMemo(() => {
    const pathname = location.pathname;

    if (pathname.startsWith(FLIGHTS_PATH)) {
      return Funnel.Air;
    }

    if (pathname.startsWith(HOTELS_PATH) || pathname.startsWith(HOMES_PATH)) {
      return Funnel.Lodging;
    }

    // cars routes are within core and not utilities, causing a circular dependency
    if (pathname.startsWith("/cars")) {
      return Funnel.Ground;
    }

    if (pathname.startsWith(getPackageRoutes().BASE_ROUTE)) {
      return Funnel.Package;
    }

    if (pathname.startsWith(ACTIVITIES_PATH)) {
      return Funnel.Activities;
    }

    if (pathname.startsWith(TRIPS_PATH)) {
      return Funnel.Trips;
    }

    return undefined;
  }, [location.pathname]);
};
